export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '云开体育提供哪些体育培训项目？',
    answer: '云开体育提供篮球、足球、游泳、羽毛球、网球、乒乓球、田径等十余项运动的专业培训服务。我们针对不同年龄段（4-18岁青少年、成人）和不同水平（入门、进阶、竞技）的学员，提供定制化的培训课程。所有教练均持有国家认证的专业资格证书。',
  },
  {
    question: '如何报名参加云开体育的培训课程？',
    answer: '您可以通过我们的官方网站或拨打客服热线进行课程咨询和报名。我们的客服人员会根据您的需求，为您推荐最合适的课程和教练，并协助您完成报名流程。首次体验课程可享受优惠价格。',
  },
  {
    question: '云开体育的赛事组织服务包括哪些内容？',
    answer: '我们的赛事组织服务涵盖赛事策划、场地布置、裁判安排、赛程管理、直播转播、赞助商对接、安全保障等全方位内容。无论是社区小型赛事还是大型锦标赛，我们都能提供专业的全程服务。',
  },
  {
    question: '运动装备的退换货政策是什么？',
    answer: '在云开体育购买的运动装备，自购买之日起7天内，如商品未经使用且包装完好，可申请无理由退换。如发现产品质量问题，30天内可申请退换。具体政策请参考各品牌的具体售后规定。',
  },
  {
    question: '场馆管理系统是否支持定制化开发？',
    answer: '是的，我们的智能场馆管理系统支持根据场馆的具体需求进行定制化开发。无论是功能模块的增减，还是界面风格的调整，我们的技术团队都能为您提供灵活的定制方案。',
  },
  {
    question: '云开体育的服务区域覆盖哪些城市？',
    answer: '云开体育目前主要服务于华东和华南地区的主要城市，包括上海、杭州、南京、深圳、广州等。我们正在积极拓展全国服务网络，预计在2026年底前覆盖全国20个重点城市。',
  },
];